module.exports = __webpack_public_path__ + "img/4.d858eb86.png";